import React  from 'react'
import useSearch from '../../../context/search/useSearch'

const SearchFilterCount: React.FC = () => {
  const { productSearchResult, searchTerm, autoCorrectedQuery } = useSearch()

  const isLoading = !productSearchResult || !searchTerm;

  const isAutocorrected = autoCorrectedQuery !== null &&
  autoCorrectedQuery !== searchTerm;

  /*   useEffect(() => {
    if (productSearchResult === null) {
      isLoading = true;
      document.title = `Search: ${productSearchResult?.total} results found for "${searchTerm}" – ${window['blubolt'].shopName}`;

    } else {
      isLoading = false;
    }
  }, [productSearchResult]) */



  if (isAutocorrected && !isLoading) {
    document.querySelector('[data-filter-sort-title]')?.remove();

    return (
      <h1 className="filter-and-sort__title filter-and-sort__title--react">{`You searched for "${searchTerm}" did you mean "${autoCorrectedQuery}"?${productSearchResult?.total ? ` (${productSearchResult.total})` : ''}`}</h1>
    )
  } else if (!isAutocorrected && !isLoading) {
    document.querySelector('[data-filter-sort-title]')?.remove();

    return (
      <h1 className="filter-and-sort__title filter-and-sort__title--react">{`You searched for "${searchTerm}"${productSearchResult?.total ? ` (${productSearchResult.total})` : ''}`}</h1>    )
  } else return null;

}

export default SearchFilterCount